import React                     from 'react';
import PropTypes                 from 'prop-types';

import withGalleryRatings        from './HigherOrderComponents/ActorProfileVideos/withGalleryRatings';

import {dislikeMedia, likeMedia} from './ActorMediaVotingActions';
import Translations              from '../utils/Translations';

class ActorMediaVoting extends React.Component {
	constructor(props) {
		super(props);
		this.onLikeClick    = this.onLikeClick.bind(this);
		this.onDislikeClick = this.onDislikeClick.bind(this);
	}

	onLikeClick() {
		likeMedia(this.props.actor.id, this.props.isSedcard ? null : this.props.album.id);
	}

	onDislikeClick() {
		dislikeMedia(this.props.actor.id, this.props.isSedcard ? null : this.props.album.id);
	}

	render() {
		const {album} 				   		           = this.props;
		const { isLiked, likes, isDisliked, dislikes } = album;

		return (
			<div>
				<div className="context-box__container -margin-top">
					{album.isVotingVisible &&
					<div className="context-box__tile-cell -button">
						<div className={('context-box__tile--property-motive -size-md -button -round-left' + ((isLiked) ? ' is-active' : ''))}
							 onClick={this.onLikeClick}
						>
							<span data-tooltip-content={Translations.get('LikeTooltip')}
                                  data-tooltip-id="tooltip-bottom"
							      className="context-box__tile--property__value h-vertical-align-middle"
							><i className="icon -icon-like-full" /> {likes}</span>
						</div>
					</div>}
					{album.isVotingVisible &&
					<div className="context-box__tile-cell -button">
						<div className={('context-box__tile--property-motive -size-md -button -round-right' + ((isDisliked) ? ' is-active' : ''))}
							 onClick={this.onDislikeClick}
						>
							<span data-tooltip-content={Translations.get('DislikeTooltip')}
                                  data-tooltip-id="tooltip-bottom"
							      className="context-box__tile--property__value h-vertical-align-middle"
							><i className="icon -icon-unlike-full" /> {dislikes}</span>
						</div>
					</div>}
				</div>
			</div>
		);
	}
}

ActorMediaVoting.propTypes = {
	album: PropTypes.shape({
		id:                 PropTypes.number,
		description:        PropTypes.string,
		contestPlace:       PropTypes.number,
		releaseDate:        PropTypes.string,
		duration:           PropTypes.string,
		hasAudio:           PropTypes.bool,
		totalViews:         PropTypes.number,
		title:              PropTypes.string,
		contestDetailsUrl:  PropTypes.string,
		likes:              PropTypes.number,
		dislikes:           PropTypes.number,
		isLiked:            PropTypes.bool,
		isDisliked:         PropTypes.bool,
		isFavorite:         PropTypes.bool,
		isVotingVisible:    PropTypes.bool,
		areCommentsVisible: PropTypes.bool,
	}),
	actor: PropTypes.shape({
		id: PropTypes.number,
	}),
	isSedcard:		 PropTypes.bool,
	isSedcardPinned: PropTypes.bool,
};

export default withGalleryRatings(ActorMediaVoting);
